import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import HotelsFilters from 'components/HotelsFilters';
import useIsMobile from 'hooks/useIsMobile';
import { HotelFilterResponse, HotelFilter } from 'models/hotelFilter';
import { TravelHotelContentLocationRequest } from 'models/hotelLocation';
import { HotelAmenities } from 'services/hotelService';

interface Props {
  show: boolean;
  onClose: () => void;
  onChange: (filters: HotelFilter) => void;
  availableFilters?: HotelFilterResponse;
  amenitiesCodes: HotelAmenities[];
  destinationPoint?: TravelHotelContentLocationRequest;
  checkInDate?: Date;
  checkOutDate?: Date;
  isLoading: boolean;
}

const HotelsFilterContainer = ({ onChange, availableFilters, amenitiesCodes, isLoading, ...props }: Props) => {
  const isMobile = useIsMobile();
  const { country, defaultFilters } = useSelector((state: RootState) => ({
    search: state.hotels.search,
    account: state.user.accountResult,
    country: state.i18n.country,
    defaultFilters: state.hotels.filters,
  }));

  const handleSearch = (filters: HotelFilter) => {
    if (isMobile) props.onClose();
    onChange(filters);
  };

  return (
    <HotelsFilters
      {...props}
      defaultFilters={defaultFilters}
      availableFilters={availableFilters}
      currency={country.currency as string}
      onSearch={handleSearch}
      amenitiesCodes={amenitiesCodes}
      isLoading={isLoading}
    />
  );
};

export default HotelsFilterContainer;
